import { supabase } from "./supabase";

/**
 * O USO das ferramentas (000303 — F10 do Plano de Melhorias de Produtos).
 *
 * Até 25/09 só o que passava pela ponte `/abrir` deixava rastro (a Edge
 * Function `abrir-card` grava em `aberturas_de_card`). As ferramentas que moram
 * aqui abrem por `<Link>`, sem ida ao servidor, e o card `url` por `<a>` — e de
 * 26 ferramentas, 21 não geravam indicador nenhum.
 *
 * ZERO regra aqui. Quem decide se a abertura conta (se a pessoa tem a
 * ferramenta, se é da equipe, se é recarga da mesma página, se o card passa pela
 * ponte) é `registrar_abertura`, no banco.
 */

/**
 * Registra a abertura, sem esperar e sem atrapalhar. Falha de rede aqui não
 * pode travar a ferramenta nem aparecer para o aluno: o indicador é da equipe,
 * a ferramenta é dele.
 */
export function registrarAbertura(card: string, curso: string | null): void {
  void supabase
    .rpc("registrar_abertura", { p_card_slug: card, p_curso_slug: curso })
    .then(({ error }) => {
      if (error) console.warn("o uso desta abertura não foi registrado:", error.message);
    });
}

export type UsoDaFerramenta = {
  slug: string;
  nome: string;
  destino: string;
  /** Aberturas com resultado ok na janela. */
  aberturas: number;
  /** Pessoas DISTINTAS que não são da equipe. */
  alunos: number;
  /** Pessoas distintas da equipe (master, grupo ou exceção). */
  equipe: number;
  /** Tentativas de quem não tinha a ferramenta. */
  negadas: number;
  ultima: string | null;
  /** Desde quando este tipo de card é registrado — interno e url, desde 25/09. */
  registra_desde: string;
};

export type UsoDasFerramentas = {
  ok: true;
  dias: number;
  medido_em: string;
  ferramentas: UsoDaFerramenta[];
};

export async function lerUsoDasFerramentas(
  dias = 30,
): Promise<UsoDasFerramentas | { ok: false; motivo?: string; detalhe?: string }> {
  const { data, error } = await supabase.rpc("cat_admin_uso_das_ferramentas", { p_dias: dias });
  if (error) return { ok: false, detalhe: error.message };
  return data as UsoDasFerramentas | { ok: false; motivo?: string; detalhe?: string };
}
